<div class="form" *ngIf="!submitted">
  <h3 class="heading">Neem contact op</h3>

  <ion-item class="item" #ionItem>
    <ion-label class="label" position="stacked">Bericht</ion-label>
    <app-form-error [errors]="err.getErrors('question')"></app-form-error>
    <ion-textarea [(ngModel)]="form.question" class="input" [ngStyle]="submitting && {'pointer-events': 'none'}" rows="6" maxlength="255"></ion-textarea>
  </ion-item>
  <ion-item class="item item-contact" #ionItem>
    <ion-label class="label" position="stacked">Voorkeur voor contact:</ion-label>
    <app-form-error [errors]="err.getErrors('response')"></app-form-error>
    <ion-select [(ngModel)]="form.response" class="input" [ngStyle]="submitting && {'pointer-events': 'none'}">
      <ion-select-option value="0">telefonisch</ion-select-option>
      <ion-select-option value="1">Per E-mail</ion-select-option>
    </ion-select>
  </ion-item>  

  <div class="buttons">
    <ion-button (click)="modal.dismiss()" [disabled]="submitting" expand="full" color="danger">Annuleren</ion-button>
    <ion-button (click)="submit()" [disabled]="submitting" expand="full" class="button-submit">{{submitting ? 'Submitting':'Verzenden'}}</ion-button>
  </div>
</div>

<p class="success-message" *ngIf="submitted">
  <span class="thank-you-head">Bedankt voor uw aanvraag!.</span>
  <br/>
  <span class="thank-you-message">Wij nemen binnen enkele dagen contact met u op</span>

  <ion-button class="close-form-message" expand="full"  (click)="modal.dismiss()" color="danger">Close</ion-button>
</p>




